import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/Home/index'
import register from '@/views/Login/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: register,
    redirect: "/register",
      children:[
        {
          path: '/register',
          name: '用户注册',
          component: () => import('@/views/Login/register/index'),
        }, 
        {
          path: '/forgotPassword',
          name: '修改密码',
          key:"forgotPassword",
          component: () => import('@/views/Login/forgotPassword/index'),
        }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: index,
    redirect: "/applyFor",
      children:[
        // {
        //   path: '/appointment',
        //   name: '我要挂号',
        //   component: () => import('@/views/Home/pages/appointment/appointment.vue'),
        // }, 
        // {
        //   path: '/information',
        //   name: '预约信息',
        //   meta:{
        //     keepAlive:false
        //   },
        //   component: () => import('@/views/Home/pages/appointment/information.vue'),
        // }, 
        // {
        //   path: '/informationDetails',
        //   name: 'informationDetails',
        //   component: () => import('@/views/Home/pages/appointment/informationDetails.vue'),
        // }, 
        {
          path: '/applyFor',
          name: '我要应聘',
          key:"applyFor",
          component: () => import('@/views/Home/pages/humanResources/applyFor.vue'),
        },
        // {
        //   path: '/applyForDetails',
        //   name: 'applyForDetails',
        //   key:"applyForDetails",
        //   component: () => import('@/views/Home/pages/humanResources/applyForDetails.vue'),
        // },
        // {
        //   path: '/satisfaction',
        //   name: '满意度调查',
        //   key:"satisfaction",
        //   component: () => import('@/views/Home/pages/satisfaction/index.vue'),
        // },
        
    ]
  },
  {
    path: '/:path(.*)*', name: 'notFound', component: () => import('@/views/Home/404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// router.beforeEach((ro,from,next)=>{
//   console.log(ro)
//   console.log(from)
//   next()
// })

// router.afterEach((ro,from)=>{
//   console.log(ro)
//   console.log(from)
 
// })

export default router
